import React from 'react';

import { Card as CardIcon } from '../../../components/icons';
import * as Api from '../../../weborder/Api';
import { basketSelectors } from '../../../weborder/redux';
import { paymentSelectors } from '../../../weborder/selectors';
import { BottomBar, Hidden } from '../../layouts';
import { SectionGroup } from '../../molecules';
import { PaymentMethodSelector } from '.';
import { ButtonPay } from './ButtonPay';
import ButtonPayStripeAlt from './ButtonPayStripeAlt';
import { getPayButtonText } from './utils/paymentOptionsUtils';

type Props = {
  currency: Api.Currency;
  currentLanguage: string;
  disabled?: boolean;
  loading?: boolean;
  onSubmit: () => void;
  payments: ReturnType<typeof paymentSelectors.getAvailablePayments>;
  price: number;
  selectedPayment: ReturnType<
    typeof basketSelectors.getSelectedPaymentOrDefault
  >;
  translate: any;
};

export const PaymentOptions = (props: Props): JSX.Element => {
  const {
    currency,
    currentLanguage,
    disabled,
    loading,
    onSubmit,
    payments,
    selectedPayment,
    price,
    translate,
  } = props;

  const handleOnSubmit = () => onSubmit;

  const noPaymentsAvailable = !payments.length;
  const placeText = getPayButtonText(selectedPayment, translate);

  const paymentButtonComponent =
    selectedPayment && selectedPayment.paymentId === 'stripe' ? (
      <ButtonPayStripeAlt
        currency={currency}
        currentLanguage={currentLanguage}
        price={price}
        data-fd="checkout-place-order"
        onClick={handleOnSubmit}
        noPaymentsAvailable={noPaymentsAvailable}
      />
    ) : (
      <ButtonPay
        currency={currency}
        currentLanguage={currentLanguage}
        disabled={disabled}
        loading={loading}
        noPaymentsAvailable={noPaymentsAvailable}
        onSubmit={onSubmit}
        placeText={placeText}
        price={price}
        translate={translate}
      />
    );

  return (
    <>
      <SectionGroup
        title={translate('Payment_methods_title')}
        icon={<CardIcon />}
      >
        <PaymentMethodSelector
          disabled={disabled || loading}
          payments={payments}
          selectedPaymentId={selectedPayment && selectedPayment.paymentId}
          translate={translate}
        />
      </SectionGroup>
      <Hidden smDown>{paymentButtonComponent}</Hidden>
      <Hidden mdUp>
        <BottomBar fixedOnly={['xs', 'sm']}>{paymentButtonComponent}</BottomBar>
      </Hidden>
    </>
  );
};
